<template>
  <div class="banner-box">
    <div :class="title === '数据报送' ? 'banner banner-submit' : 'banner'">
      <el-image class="banner-bg" :src="title === '数据报送' ? submitImage : bannerImage"></el-image>
      <div class="little-box" />
      <div class="big-box">
        <div class="big-box-name">{{ title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    // 类型检查
    title: {
      type: String,
      default: "报告查询"
    }
  },
  data() {
    return {
      content: "",
      bannerImage: require('../../assets/report.jpg'),
      submitImage: require('../../assets/submit.jpg')
    }
  }

}
</script>
<style scoped>
.banner-box {
  width: 100%;
  min-height: 368px;
}

.banner {
  width: 1140px;
  height: 368px;
  margin: 0 auto 0;
  padding-top: 110px;
  position: relative;
}

.banner-bg {
  width: 1140px;
  height: 368px;
}

.little-box {
  width: 70px;
  height: 70px;
  background: rgba(63, 140, 255, 0.5);
  position: absolute;
  top: 272px;
  left: 312px;
  z-index: 1;
}

.big-box {
  width: 380px;
  height: 110px;
  background: rgba(63, 140, 255, 0.8);
  position: absolute;
  top: 197px;
  left: -33px;
  z-index: 100;
  display: flex;
  align-items: center;
}

.big-box-name {
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(255, 255, 255, 1);
  margin-left: 57px;
}
</style>



// WEBPACK FOOTER //
// src/components/banner/index.vue